export default {
    trueblack: '#000000',
    black: '#0A0B09',
    gray: '#111210',
    slate: '#232328',
    red: '#DC4C40',
    purple: '#6E7FFE',
    white: '#ffffff',
};
